// Dynamically Load JS
// First argument: is for the script attribute. It accepts only 'defer' or 'async'
// Second argument: allows you to set the type attribute. Set argument to '' to avoid setting type
// Third argument: pass in your file name. you must pass it in using the asset_url filter. e.g.: `{{ 'your-javascript-file.js' | asset_url}}`
// Fourth argument: optional error handling. Accepts a boolean
// Full example of how to use this function: DynamicallyLoadJS('defer', 'module', `{{ 'syour-javascript-file.js' | asset_url}}`, true);
const GLOBAL_FILE_OBJ = {loadedFiles: []};
const LOADED_FILES_ARR = GLOBAL_FILE_OBJ.loadedFiles;

const DynamicallyLoadJS = (attr, type, fileName, errHandlingOn) => {
  const addScriptAttributes = (script, str) => {
    script.src = str;
    script.setAttribute(attr, '');

    if (type != '') {
      script.setAttribute('type', type);
      return script;
    }
    return script;
  };

  const appendScript = () => {
    const scriptEl = document.createElement('script');

    addScriptAttributes(scriptEl, fileName);
    document.head.appendChild(scriptEl);
    LOADED_FILES_ARR.push(fileName);

    if (errHandlingOn) {
      console.log(
        `%c😝 Dynamically added script called "${fileName}"`,
        `color: magenta;`,
      );
    }
  };

  if (!LOADED_FILES_ARR.includes(fileName) && !errHandlingOn) {
    appendScript();
  } else if (!LOADED_FILES_ARR.includes(fileName) && errHandlingOn) {
    console.log(
      `%c"${fileName}" detected as not already dynamically loaded; attempting to create and add now...`,
      `color: orange;`,
    );
    appendScript();
  } else if (LOADED_FILES_ARR.includes(fileName) && errHandlingOn) {
    console.log(
      `%c"${fileName}" detected as already loaded. Here's a list of dynamically loaded files: ${LOADED_FILES_ARR}`,
      `color: cyan;`,
    );
  }
};

// GA4 Events
const ExecuteGA4Event = (eventObject, onLoad = false) => {
  const pushData = () => {
    if (eventObject) {
      console.log('%cGA4 Event Captured!', 'color: green;');
      console.log(eventObject);
      window.dataLayer.push(eventObject, {event_params: undefined});
    }
  };

  if (onLoad || !window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    pushData();
  } else {
    pushData();
  }
};

// Make ExecuteGA4Event globally available for ES modules
window.ExecuteGA4Event = ExecuteGA4Event;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  setTimeout(() => {
    elementToFocus.focus();
  }, 300);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDisclosure = this.querySelector('.mobile-facets__disclosure');
    this.triggerButton = this.querySelector('.mobile-facets__open-wrapper');
    this.facetForm = this.querySelector('facet-filters-form');
    this.closeButton = this.querySelector(
      '[aria-label="Close dialog"].mobile-facets__close',
    );

    this.mainDetailsToggle = this.triggerButton.querySelector('details');

    this.addEventListener('click', () => {
      trapFocus(this.facetForm, this.triggerButton);
    });
    this.addEventListener('keydown', this.keyDown.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button').forEach((button) => {
      if (button.classList.contains('mobile-facets__open-wrapper')) {
        button.addEventListener('click', this.onTriggerButtonClick.bind(this));
      } else if (button.classList.contains('mobile-facets__close-button')) {
        button.addEventListener('click', (event) => {
          const detailsElement = event.currentTarget.closest('details[open]');
          if (detailsElement) {
            this.closeSubmenu(detailsElement);
            detailsElement.querySelector('summary').focus();
          }
        });
        button.addEventListener('keydown', (event) => {
          if (event.code === 'Enter' || event.key === 'Enter') {
            event.preventDefault();
            const detailsElement = event.currentTarget.closest('details[open]');
            if (detailsElement) {
              this.closeSubmenu(detailsElement);
              detailsElement.querySelector('summary').focus();
            }
          }
        });
      } else if (button.classList.contains('apply-button')) {
        button.addEventListener('click', (event) => {
          this.onCloseButtonClick(event);
        });

        button.addEventListener('keydown', (event) => {
          if (
            window.innerWidth < 750 &&
            (event.key === 'Tab' || event.code === 'Tab')
          ) {
            event.preventDefault();
            const closeButton = document.querySelector(
              '[aria-label="Close dialog"].mobile-facets__close',
            );
            closeButton.focus();
          }

          if (
            event.code === 'Enter' ||
            event.key === 'Enter' ||
            event.code === 'Space' ||
            event.key === ' '
          ) {
            this.onCloseButtonClick(event);
          }
        });
      } else {
        button.addEventListener('click', (event) => {
          if (event.target.classList.contains('mobile-facets__checkbox'))
            return;

          this.onCloseButtonClick(event);
        });
      }
    });
  }

  onTriggerButtonClick(event) {
    event.preventDefault();
    const isOpen = this.triggerButton.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.closeMenuDrawer(event, this.triggerButton);
    } else {
      this.openMenuDrawer(
        this.triggerButton,
        window.innerWidth < 751
          ? document.getElementById('FacetFiltersFormMobile')
          : this.triggerButton,
      );
    }

    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`,
      );
    }
  }

  keyDown(event) {
    if (event.code === 'Escape' || event.key === 'Escape') {
      this.onCloseButtonClick(event);
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(triggerElement, differentTrigger = triggerElement) {
    setTimeout(() => {
      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.classList.add('menu-opening');
      } else if (this.mainDisclosure) {
        this.mainDisclosure.classList.add('menu-opening');
        this.facetForm.style.display = 'block';
      }
    }, 100);
    triggerElement.setAttribute('aria-hidden', true);
    triggerElement.setAttribute('disabled', 'disabled');

    const focusTarget = this.mainDetailsToggle || this.facetForm;
    if (focusTarget) {
      trapFocus(focusTarget, differentTrigger);
    }
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDisclosure.classList.remove('menu-opening');
    this.cleanClasses();

    if (this.triggerButton) {
      this.triggerButton.removeAttribute('aria-hidden');
      this.triggerButton.removeAttribute('disabled');
    }

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);

    this.facetForm.style.display = 'none';
  }

  onCloseButtonClick(event) {
    if (event.target.classList.contains('mobile-facets__checkbox')) return;

    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details[open]');

    if (detailsElement) {
      this.closeSubmenu(detailsElement);
    } else {
      this.closeMenuDrawer(event, this.triggerButton);
    }
  }

  closeSubmenu(detailsElement) {
    this.cleanClasses();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(element) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (element.hasAttribute('open')) {
          this.cleanClasses();
          element.removeAttribute('open');
        }

        const parentDetails =
          element.closest &&
          element.closest('details[open].mobile-facets__disclosure');
        if (parentDetails) {
          const summary = parentDetails.querySelector('summary');
          if (summary) {
            trapFocus(parentDetails, summary);
          }
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  cleanClasses() {
    const cleanSubmenuClass = document.querySelectorAll(
      '.mobile-facets__main.submenu-open',
    );
    const cleanDetailsClass = document.querySelectorAll(
      '.mobile-facets__details.menu-opening',
    );

    if (cleanSubmenuClass.length > 0) {
      cleanSubmenuClass.forEach((detail) => {
        detail.classList.remove('submenu-open');
      });
    }

    if (cleanDetailsClass.length > 0) {
      cleanDetailsClass.forEach((detail) => {
        detail.classList.remove('menu-opening');
        detail.removeAttribute('open');
      });
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide(false);
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide(this);
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const mobileDestination = document.getElementById(
          `price-${this.dataset.section}-mobile`,
        );
        const mobileSource = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-mobile`,
        );
        if (mobileSource && mobileDestination)
          mobileDestination.innerHTML = mobileSource.innerHTML;

        const addToCartDestination = document.querySelector(
          '[name="add"] [data-pdp-add-button-price]',
        );

        const addToCartSource = html.querySelector(
          `[name="add"] [data-pdp-add-button-price]`,
        );

        if (addToCartSource && addToCartDestination) {
          addToCartDestination.dataset.pdpAddButtonPrice =
            addToCartSource.dataset.pdpAddButtonPrice;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // Keeps the "selected color" legend + swatch image strip in sync. Lives on the
    // custom element (rather than a per-render inline <script>) so it works correctly
    // no matter how many <variant-radios> instances exist on the page at once (e.g.
    // the main product form and a simultaneously open quick-add modal).
    this.addEventListener('change', this.updateSelectedSwatch);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }

  updateSelectedSwatch(event) {
    const input = event.target;
    if (!input.matches('input[type="radio"]') || !input.checked) return;

    const optionWrapper = input.closest('.selected__wrapper');
    if (!optionWrapper) return;

    const label = optionWrapper.querySelector('.selected-color');
    if (label) {
      label.textContent = input.value;
      label.dataset.selectedVariant = input.dataset.valueId;
    }

    if (!optionWrapper.hasAttribute('data-has-images')) return;

    const selectedValueId = input.dataset.valueId;
    optionWrapper.querySelectorAll('[data-value-id]').forEach((el) => {
      el.classList.toggle(
        'is-selected',
        el.dataset.valueId === selectedValueId,
      );
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Google Tag Manager Start
function homeEvent() {
  if (window.location.href === 'https://www.petivity.com/') {
    setTimeout(function () {
      $('#MainContent a:not([data-use-ga-js="false"])').each(function () {
        let linkText = $(this).text().toLowerCase().trim();
        let linkHref = $(this).attr('href').trim();
        if (linkText.includes('slide-image')) {
          let linkHrefLast = linkHref.split('/').pop();
          linkText = linkHrefLast.replaceAll('-', ' ');
        }
        $(this).attr('data-category', 'homepage');
        $(this).attr('data-action', linkText);
        $(this).attr('data-label', linkHref);
      });
    }, 1000);
  }
}
homeEvent();

function initRakutenPanel() {
  let waitInterval = setInterval(function () {
    if (
      $ !== undefined &&
      $('#onetrust-pc-sdk').length > 0 &&
      $('.ot-pc-refuse-all-handler').length > 0
    ) {
      $('#onetrust-pc-sdk').on(
        'click',
        '#accept-recommended-btn-handler',
        function () {
          window.__rmuspc = 'YN';
          console.log(window.__rmuspc);
          sessionStorage.setItem('__rmuspc', 'YN');
        },
      );
      $('#onetrust-pc-sdk').on(
        'click',
        '.ot-pc-refuse-all-handler',
        function () {
          window.__rmuspc = 'YY';
          console.log(window.__rmuspc);
          sessionStorage.setItem('__rmuspc', 'YY');
        },
      );
      $('#onetrust-pc-sdk').on(
        'click',
        '.save-preference-btn-handler',
        function () {
          if ($('.category-switch-handler').attr('aria-checked') === 'true') {
            window.__rmuspc = 'YN';
            console.log(window.__rmuspc);
            sessionStorage.setItem('__rmuspc', 'YN');
          } else {
            window.__rmuspc = 'YY';
            console.log(window.__rmuspc);
            sessionStorage.setItem('__rmuspc', 'YY');
          }
        },
      );
      clearInterval(waitInterval);
    }
  }, 250);
}
function rakutenOptOut() {
  if (sessionStorage && sessionStorage.getItem('__rmuspc')) {
    window.__rmuspc = sessionStorage.getItem('__rmuspc');
  } else {
    window.__rmuspc = '--';
    console.log(window.__rmuspc);
    sessionStorage.setItem('__rmuspc', '--');
    let waitInterval = setInterval(function () {
      if ($ !== undefined && $('#onetrust-banner-sdk').length > 0) {
        $('#onetrust-banner-sdk').on(
          'click',
          '#onetrust-accept-btn-handler',
          function () {
            window.__rmuspc = 'YN';
            console.log(window.__rmuspc);
            sessionStorage.setItem('__rmuspc', 'YN');
          },
        );
        $('#onetrust-pc-btn-handler').click(function () {
          initRakutenPanel();
        });
        clearInterval(waitInterval);
      }
    }, 250);
  }
}
rakutenOptOut();

function rechargeLoginLink() {
  let rechargeLoginLink = document.querySelector(
    '.recharge .rc_layout__full a',
  );
  if (rechargeLoginLink) {
    rechargeLoginLink.href = '/account';
    document.title = 'Manage Subscriptions';
  }
  let rechargeHeaderText = document.querySelector(
    '.recharge .rc_header-settings__description',
  );
  if (rechargeHeaderText) {
    rechargeHeaderText.innerHTML = rechargeHeaderText.innerHTML
      .replace('Shopify', '')
      .replace('ID', '');
  }
}
rechargeLoginLink();

// <!-- Start Product Card -->
const productCardTemplate = function () {
  const toggleClass = function (e) {
    const slideGranParent = e.target.closest(`.petivity-product-card`);
    const parentClass = slideGranParent.getAttribute('data-parentClass');
    const slideParent = e.target.closest(`${parentClass}`);

    const mainImage = slideParent.querySelector(
      '.petivity-product-card__main-image',
    );
    const mainImageHidden =
      mainImage.getAttribute('aria-hidden') === 'true' ? false : true;
    const hoverImage = slideParent.querySelector(
      '.petivity-product-card__hover-image',
    );
    const hoverImageHidden =
      hoverImage.getAttribute('aria-hidden') === 'true' ? false : true;
    slideParent.classList.toggle('show__hover');

    mainImage.setAttribute('aria-hidden', mainImageHidden);
    hoverImage.setAttribute('aria-hidden', hoverImageHidden);
  };

  const bulletsChange = function (e) {
    e.preventDefault();
    const target = e.target.closest('.bullet');
    if (target.classList.contains('active')) {
      return;
    }

    const parent = target.closest('.petivity-product-card__bullets');
    const bullets = parent.querySelectorAll('.bullet');

    bullets.forEach((bullet) => {
      bullet.classList.toggle('active');
      const bulletSelected =
        bullet.getAttribute('aria-selected') === 'true' ? false : true;

      bullet.setAttribute('aria-selected', bulletSelected);
    });
    toggleClass(e);
  };

  const productCards = document.querySelectorAll('.petivity-product-card');

  if (productCards.length > 0) {
    productCards.forEach((productCard) => {
      const bullets = productCard.querySelectorAll('.bullet');
      bullets.forEach((bullet) => {
        bullet.addEventListener('click', (e) => {
          bulletsChange(e);
        });
      });

      productCard.addEventListener('mouseenter', (e) => {
        e.target.querySelector('.bullet:not(.active)')?.click();
      });

      productCard.addEventListener('mouseleave', (e) => {
        e.target.querySelector('.bullet:not(.active)')?.click();
      });

      if (!productCard.classList.contains('no--touch')) {
        let startX;
        let startY;
        const threshold = 50;

        productCard.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        });

        productCard.addEventListener('touchmove', (e) => {
          const parent = e.target.closest('.petivity-product-card');
          if (!startX || !startY) {
            return;
          }

          const distX = e.touches[0].clientX - startX;
          const distY = e.touches[0].clientY - startY;

          if (
            Math.abs(distX) > Math.abs(distY) &&
            Math.abs(distX) > threshold
          ) {
            if (distX > 0) {
              parent.querySelector('.bullet:not(.active)').click();
            } else {
              parent.querySelector('.bullet:not(.active)').click();
            }
            startX = null;
            startY = null;
          }
        });
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  productCardTemplate();
});
// <!-- End Product Card -->
